/**
 * JULI Theme Interactive Controller
 * Handles Modals, Dropdowns, Video Player, and Smooth Showcase Scrolling
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    initModals();
    initDropdowns();
    initShowcaseDrag();
    initMobileNav();
  });

  /* ==========================================================================
     Modal Controller (Talk to JULI & Video Popup)
     ========================================================================== */
  function initModals() {
    const contactModal = document.getElementById('juli-contact-modal');
    const videoModal = document.getElementById('juli-video-modal');
    const videoPlayer = document.getElementById('juli-video-player');

    // Open Contact Modal
    document.querySelectorAll('[data-juli-modal="contact"]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openModal(contactModal);
      });
    });

    // Open Video Modal
    document.querySelectorAll('[data-juli-modal="video"]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const videoSrc = trigger.getAttribute('data-video-src');
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        if (videoPlayer && videoSrc) {
          if (videoPlayer.src !== videoSrc) {
            videoPlayer.src = videoSrc;
          }
          if (isMobile) {
            videoPlayer.setAttribute('controls', 'controls');
            videoPlayer.controls = true;
          } else {
            videoPlayer.removeAttribute('controls');
            videoPlayer.controls = false;
          }
          videoPlayer.play().catch(() => {});
          if (isMobile && typeof videoPlayer.webkitEnterFullscreen === 'function') {
            try { videoPlayer.webkitEnterFullscreen(); } catch (err) {}
          }
        }
        openModal(videoModal);
      });
    });

    if (videoPlayer) {
      videoPlayer.addEventListener('webkitendfullscreen', () => {
        closeModal(videoModal);
      });
    }

    // Close buttons
    document.querySelectorAll('[data-juli-modal-close]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const modal = btn.closest('.juli-modal-backdrop');
        closeModal(modal);
      });
    });

    // Click outside container to close
    document.querySelectorAll('.juli-modal-backdrop').forEach((modal) => {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          closeModal(modal);
        }
      });
    });

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const activeModal = document.querySelector('.juli-modal-backdrop.is-active');
        if (activeModal) {
          closeModal(activeModal);
        }
      }
    });

    function openModal(modal) {
      if (!modal) return;
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      const firstInput = modal.querySelector('input, button:not([data-juli-modal-close])');
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 100);
      }
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
      if (modal === videoModal && videoPlayer) {
        videoPlayer.pause();
        videoPlayer.currentTime = 0;
      }
    }
  }

  /* ==========================================================================
     Dropdown Disclosures
     ========================================================================== */
  function initDropdowns() {
    const navItems = document.querySelectorAll('.juli-nav-item');

    navItems.forEach((item) => {
      const linkBtn = item.querySelector('.juli-nav-link-btn');
      const dropdown = item.querySelector('.juli-dropdown-menu');

      if (!linkBtn || !dropdown) return;

      // Click to toggle on mobile/touch devices
      linkBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = item.classList.contains('is-open');
        navItems.forEach((other) => other.classList.remove('is-open'));
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.juli-nav-item')) {
        navItems.forEach((item) => item.classList.remove('is-open'));
      }
    });
  }

  /* ==========================================================================
     Showcase Carousel Drag / Scroll
     ========================================================================== */
  function initShowcaseDrag() {
    const carousel = document.querySelector('.juli-showcase-carousel');
    if (!carousel) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    carousel.addEventListener('mousedown', (e) => {
      isDown = true;
      carousel.classList.add('is-dragging');
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener('mouseleave', () => {
      isDown = false;
      carousel.classList.remove('is-dragging');
    });

    carousel.addEventListener('mouseup', () => {
      isDown = false;
      carousel.classList.remove('is-dragging');
    });

    carousel.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 1.5;
      carousel.scrollLeft = scrollLeft - walk;
    });
  }

  /* ==========================================================================
     Mobile Navigation Toggle
     ========================================================================== */
  function initMobileNav() {
    const toggle = document.querySelector('.juli-mobile-toggle');
    const pillGroup = document.querySelector('.juli-nav-pill-group');

    if (!toggle || !pillGroup) return;

    toggle.addEventListener('click', () => {
      const isVisible = pillGroup.style.display === 'flex';
      pillGroup.style.display = isVisible ? 'none' : 'flex';
      pillGroup.style.position = isVisible ? '' : 'absolute';
      pillGroup.style.top = isVisible ? '' : '100%';
      pillGroup.style.left = isVisible ? '' : '20px';
      pillGroup.style.right = isVisible ? '' : '20px';
      pillGroup.style.flexDirection = isVisible ? '' : 'column';
      pillGroup.style.alignItems = isVisible ? '' : 'flex-start';
    });
  }
})();
